module.exports = __webpack_public_path__ + "static/media/cover-img.507e5a90.jpg";